<template>
	<div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
		</base-header>
		<div class="container-fluid mt--9" style="max-width: 2000px;">
			<div class="d-flex mb-3 mb-xl-0 flex-column flex-xl-row">
        <div class="mr-3 flex-grow-1" style="min-width: 1px;">
          <!-- Datos del cliente -->
          <div class="card shadow mb-3">
            <div v-if="customer">
              <div class="card-header bg-transparent">
                <div class="d-flex flex-column flex-xl-row align-items-start justify-content-xl-between align-items-xl-center">
                  <div class="flex-grow-1 mb-2 mb-xl-0">
                    <div class="d-flex align-items-center">
                      <span class="m-0 h3">{{invoice.CardName}}
                        <span class="text-muted m-0 h4">{{invoice.CardCode}}</span>
                      </span>
                    </div>
                    <h4 class="text-muted m-0 d-flex align-items-center font-weight-normal">
                      <span>Factura
                        <span style="letter-spacing: 0.5px;">
                          #{{$route.params.DocNum}}
                        </span>
                      </span>
                      <badge v-if="invoice.DocumentStatus === 'bost_Open'" type="primary" class="ml-2">Abierta</badge>
                      <badge v-else-if="invoice.CancelStatus === 'csYes'" type="danger" class="ml-2">Cancelada</badge>
                      <badge v-else-if="invoice.DocumentStatus === 'bost_Close'" type="light" class="ml-2">Cerrada</badge>

                      <badge v-if="invoice.U_TS_ReportID" type="success" class="ml-2">Timbrada</badge>
                      <badge v-else-if="!invoice.U_TS_ReportID" type="light" class="ml-2">Sin Timbrar</badge>

                      <badge 
                        v-if="invoice.U_WebPrintedBy" 
                        type="info" 
                        class="ml-2" 
                        :title="`PDF de Factura impreso por ${invoice.U_WebPrintedBy}`">Impresa</badge>
                    </h4>
                  </div>
                  <div class="d-flex flex-wrap flex-xl-row ml-xl-4 align-items-start justify-content-center">
                    <base-button
                      @click="layoutPDF();"
                      icon="fas fa-file-pdf"
                      size="sm"
                      class="mb-2"
                      :disabled="!invoice || downloadingLayoutPDF">
                      Factura sin precios
                    </base-button>
                    <base-button
                      @click="couriersPDF();"
                      icon="fas fa-file-pdf"
                      size="sm"
                      class="mb-2"
                      :disabled="!invoice || downloadingCouriersPdf">
                      Paqueterías
                    </base-button>
                    <base-button
                      v-if="(invoice.U_TS_ReportID && invoice.U_WebTimbrado == 'Y')"
                      @click="invoiceXML();"
                      icon="fas fa-file-code"
                      size="sm"
                      class="mb-2"
                      :disabled="!invoice || downloadingXml">
                      XML
                    </base-button>
                    <base-button
                      v-if="(invoice.U_TS_ReportID && invoice.U_WebTimbrado == 'Y') || invoice.U_WebTimbrado == 'N'"
                      @click="invoicePDF();"
                      icon="fas fa-file-pdf"
                      size="sm"
                      :disabled="!invoice || downloadingPdf">
                      PDF
                    </base-button>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="d-flex flex-column flex-xl-row">
                  <div class="d-flex my-1">
                    <h5 class="m-0">RFC</h5>
                    <p class="text-xs pl-2 m-0"><b>{{invoice.FederalTaxID}}</b></p>
                  </div>
                  <div class="d-flex my-1 ml-xl-4" v-if="customer.U_TS_RegFiscal && regimenes">
                    <h5 class="m-0">Régimen Fiscal</h5>
                    <p class="text-xs pl-2 m-0"><b>{{regimenes.find(x => x.Code === customer.U_TS_RegFiscal).Name}}</b></p>
                  </div>
                  <div class="d-flex my-1 ml-xl-4">
                    <h5 class="m-0">Uso CFDI</h5>
                    <p class="text-xs pl-2 m-0"><b>{{ invoice.U_TS_UsoCFDI40 }}</b></p>
                  </div>
                </div>
              </div>
              </div>
              <div v-else style="height: 700px; padding-top: 300px;">
                <base-loader></base-loader>
              </div>
          </div>
          <!-- Detalles de factura -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header">
              <h6 class="heading-small text-muted m-0 p-0">Detalles de Factura</h6>
            </div>
            <div class="card-body">
              <div class="container m-0 p-0">
              <div class="row">
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Almacén</h5>
                  <p class="text-xs pl-2 m-0"><b>{{invoice.DocumentLines[0].WarehouseCode}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">C. P. de Almacén</h5>
                  <p class="text-xs pl-2 m-0"><b>{{zipCode}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="invoice.SalesPersonCode && salesPersonOptions">
                  <h5 class="m-0">Vendedor</h5>
                  <p class="text-xs pl-2 m-0"><b>{{salesPersonOptions.find(x => x.SalesEmployeeCode === invoice.SalesPersonCode).SalesEmployeeName}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" >
                  <h5 class="m-0">Contacto</h5>
                  <p class="text-xs pl-2 m-0 text-truncate" v-if="invoice.ContactPersonCode && customer">
                    <b>{{customer.ContactEmployees.find(x => x.InternalCode === invoice.ContactPersonCode).Name}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Moneda</h5>
                  <p class="text-xs pl-2 m-0"><b>{{invoice.DocCurrency}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Fecha contable</h5>
                  <p class="text-xs pl-2 m-0"><b>{{invoice.DocDate}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Fecha de entrega</h5>
                  <p class="text-xs pl-2 m-0"><b>{{invoice.DocDueDate}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="globalInformation">
                  <h5 class="m-0">Periodicidad</h5>
                  <p class="text-xs pl-2 m-0"><b>{{globalInformation.periodicity}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="globalInformation">
                  <h5 class="m-0">Meses</h5>
                  <p class="text-xs pl-2 m-0"><b>{{globalInformation.months}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="globalInformation">
                  <h5 class="m-0">Año</h5>
                  <p class="text-xs pl-2 m-0"><b>{{globalInformation.year}}</b></p>
                </div>
              </div>
            </div>
            </div>
          </div>
          <!-- Tabla de artículos -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header border-0">
              <h6 class="heading-small text-muted m-0 p-0">Artículos</h6>
            </div>
              <div v-if="invoice" class="table-responsive custom-table">
                <base-table thead-classes="thead-light" :data="invoice.DocumentLines">
                <template #columns>
                  <th width="5%">#</th>
                  <th width="35%" class="pl-5">Artículo</th>
                  <th width="5%" class="text-center">Pedimento</th>
                  <th width="5%" class="text-right">Rollos</th>
                  <th width="10%" class="text-right">Cantidad</th>
                  <th width="10%" >U. medida</th>
                  <th width="10%" class="text-right">Precio por unidad</th>
                  <th width="10%" class="text-right">Total</th>
                </template>
                <template #default="{ row }">
                  <td width="5%">
                    {{ row.LineNum + 1 }}
                  </td>
                  <td scope="row" width="35%" class="pl-5 text-xs">
                    <b> {{ row.ItemCode }} </b>
                    {{ row.ItemDescription }}
                    <br>
                    <b class="text-primary">{{ row.U_SubCode }} </b>
                    <span class="text-primary">{{ row.U_SubDescription }}</span>
                  </td>
                  <td scope="row" width="5%" class="text-center text-xs">
                    {{ row.U_PedimentNum || '-'}}
                  </td>
                  <td scope="row" width="5%" class="text-right text-xs">
                    {{ row.U_Rolls }}
                  </td>
                  <td scope="row" width="10%" class="text-right text-xs">
                    {{ row.Quantity }}
                  </td>
                  <td scope="row" width="10%" class="text-xs">
                    {{ row.MeasureUnit}}
                  </td>
                  <td scope="row" width="10%" class="text-right text-xs">
                    {{ currencyFormat(row.UnitPrice, currency.iso) }}
                  </td>
                  <td scope="row"  width="10%" class="text-right text-xs">
                    {{ currencyFormat(currency.iso === 'MXN' ? row.RowTotalSC : row.RowTotalFC, currency.iso) }}
                  </td>
                </template>
                </base-table>
              </div>
              <div class="d-flex justify-content-end px-4 border-top py-2">
                <table class="text-right text-sm">
                  <tr>
                    <th class="pr-4"><h5 class="my-1">Subtotal</h5></th>
                    <td>
                      {{ currencyFormat(currency.iso === 'MXN' ? invoice.DocTotalSys - invoice.VatSumSys : invoice.DocTotalFc - invoice.VatSumFc, currency.iso) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pr-4"><h5 class="my-1">IVA</h5></th>
                    <td>
                      {{ currencyFormat(currency.iso === 'MXN' ? invoice.VatSumSys : invoice.VatSumFc, currency.iso) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pr-4"><h5 class="my-1">Total</h5></th>
                    <td>
                      {{ currencyFormat(currency.iso === 'MXN' ? invoice.DocTotalSys : invoice.DocTotalFc, currency.iso) }}
                    </td>
                  </tr>
                </table>
              </div>
          </div>
          <!-- Datos Adicionales -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header">
              <h6 class="heading-small text-muted m-0 p-0">Datos adicionales</h6>
            </div>
            <div class="card-body">
              <div class="container m-0 p-0">
                <div class="row">
                <div class="col-6 col-lg-6 d-flex my-1">
                  <h5 class="m-0">Referencia</h5>
                  <p class="text-xs ml-2 m-0"><b>{{invoice.NumAtCard}}</b></p>
                </div>
                <div class="col-6 col-lg-6 d-flex my-1">
                  <h5 class="m-0">Comentarios</h5>
                  <p class="text-xs ml-2 m-0"><b>{{invoice.Comments}}</b></p>
                </div>
                <div class="col-6 col-lg-6 d-flex my-1">
                  <h5 class="m-0">Doc. Relacionado</h5>
                  <p class="text-xs ml-2 m-0"><b>{{invoice.U_WebRefObj}} {{invoice.U_WebRefDocNum}}</b></p>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="custom-side-cards">
          <!-- Historial de documentos -->
          <div class="card shadow mb-3">
            <div v-if="customer">
              <div class="card-header">
                <h6 class="heading-small text-muted m-0 p-0">Historial de Documentos</h6>
              </div>
              <document-history :docNum="$route.params.DocNum" table="OINV" @reload="load()"/>
            </div>
            <div v-else class="py-6">
              <base-loader></base-loader>
            </div>
          </div>
          <!-- Facturar a -->
          <div class="card shadow mb-3 " v-if="customer">
              <div class="card-header py-3">
                <h6 class="heading-small text-muted m-0">Facturar a:</h6>
              </div>
              <div class="card-body py-2">
                <div class="d-flex mb-1 ">
                  <i class="fas fa-map-marker-alt mr-2 pt-1 text-gray"></i>
                  <div class="text-xs m-0 font-weight-bold text-default">
                    <span>{{invoice.AddressExtension.BillToStreet}} </span>
                    <span>{{invoice.AddressExtension.BillToStreetNo}} </span>
                    <span>{{invoice.AddressExtension.BillToBlock}}</span>
                    <br>
                    <span>{{invoice.AddressExtension.BillToZipCode}} </span>
                    <span>{{invoice.AddressExtension.BillToCity}} </span>
                    <span>{{invoice.AddressExtension.BillToState}}</span>
                    <br>
                    <span>{{invoice.AddressExtension.BillToCountry}}</span>
                  </div>
                </div>
                <hr class="my-2">
                <div class="d-flex align-items-center mb-1">
                  <h5 class="m-0">Vía de Pago</h5>
                  <span class="text-xs m-0 ml-2">
                    {{invoice.PaymentMethod}}
                  </span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <h5 class="m-0">Método de Pago</h5>
                  <span class="text-xs m-0 ml-2">
                    {{paymentMethod}}
                  </span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <h5 class="m-0">Condiciones de Pago</h5>
                  <span v-if="paymentGroup" class="text-xs m-0 ml-2">
                    {{paymentGroup.PaymentTermsGroupName}}
                  </span>
                </div>
              </div>
          </div>
          <!-- Enviar a -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header">
              <h6 class="heading-small text-muted m-0 p-0">Enviar a:</h6>
            </div>
            <div class="card-body py-2">
              <div class="d-flex mb-1">
                <i class="fas fa-map-marker-alt mr-2 pt-1 text-gray"></i>
                <div class="text-xs m-0 font-weight-bold text-default">
                  <span>{{invoice.AddressExtension.ShipToStreet}} </span>
                  <span>{{invoice.AddressExtension.ShipToStreetNo}} </span>
                  <span>{{invoice.AddressExtension.ShipToBlock}}</span>
                  <br>
                  <span>{{invoice.AddressExtension.ShipToZipCode}} </span>
                  <span>{{invoice.AddressExtension.ShipToCity}} </span>
                  <span>{{invoice.AddressExtension.ShipToState}}</span>
                  <br>
                  <span>{{invoice.AddressExtension.ShipToCountry}}</span>
                </div>
              </div>
              <hr class="my-2">
              <div class="d-flex align-items-center mb-1">
                <h5 class="m-0">Método de envío</h5>
                <span v-if="shippingMethod" class="text-xs m-0 ml-2">
                  {{shippingMethod.Description}}
                </span>
              </div>
              <div class="d-flex align-items-center mb-1">
                <h5 class="m-0">Pago flete</h5>
                <span v-if="freightPayment" class="text-xs m-0 ml-2">
                  {{freightPayment.Description}}
                </span>
              </div>
            </div>
          </div>
          <!-- Paquetes -->
          <div
            v-if="customer"
            class="card shadow mb-3 pb-3"
          >
            <div class="card-header d-flex justify-content-between align-items-center py-3">
              <h6 class="heading-small text-muted m-0 p-0">Guías</h6>
              <base-button 
                @click="modals.newTracking = true" 
                size="sm" 
                icon="fas fa-plus">
                Nueva guía
              </base-button>
            </div>
            <div class="card-body py-2 d-flex flex-column" style="max-height: 200px; overflow-y: auto; gap: 12px;">

                <div v-if="trackings && trackings.length > 0">
                  <div 
                    v-for="(t, index) in trackings" 
                    :key="index" 
                    class="d-flex justify-content-between align-items-center"
                    style="cursor: pointer;"
                    @click="openTracking(t, index)"
                  >
                  <div v-if="t.shipment" class="text-xs text-blue">
                    {{ t.shipment.carrier }}
                    {{ t.shipment.service }}
                    {{ t.packages.length }} Paquete(s)
                  </div>
                  <div v-else class="text-xs text-blue">
                    PAQUETEXPRESS
                    {{ t.isOcurre ? 'Ocurre' : 'Estándar' }}
                    {{ t.packages.length }} Paquete(s)
                  </div>
                  <div class="remove-button" @click.stop="removeTracking(index)">
                    <i class="fa fa-trash fa-xs"></i>          
                  </div>
                  </div>
                </div>

              <TrackingNumbers
                ref="trackingNumbers"
                docType="invoice"
                :docNum="invoice.DocNum" 
                :showEmpty="!(trackings && trackings.length > 0)"
              />
            </div>
          </div>
          <!-- Boton de Timbrar -->
          <div v-if="
            customer && 
            invoice.U_WebError != null && 
            invoice.CardCode !== 'C02858' &&
            (invoice.CardCode !== 'C01100' && invoice.NumAtCard !== 'MuestraCPM')
          "
          class="mb-2"
          >
            <base-button
              v-if="!stamping"
              @click="stampInvoice();" 
              block
              :disabled="stamping || !canStamp"
            >
              Timbrar
            </base-button>
            <div v-if="stamping" class="flex justify-items-center w-100">
              <base-loader text="Timbrando. Espere un momento..."></base-loader>
            </div>
          </div>

          <!-- Boton de Generar Guías -->
          <base-button
            v-if="trackings && trackings.length && invoice.Cancelled === 'tNO'"
            @click="generateTracking();" 
            block
            icon="fas fa-check"
            class="mb-2"
            :disabled="generating"
          >
            Generar guía(s)
          </base-button>

          <!-- Botón de Reenviar -->
          <div v-if="customer">
            <base-button
              @click="openEmailsList();"
              block
              icon="fas fa-envelope"
              :disabled="false"
              type="primary"
            >
              Reenviar Correo
            </base-button>
          </div>

        </div>
			</div>
		</div>

    <modal :show.sync="modals.emails" modal-classes="modal-dialog-centered modal-md">
      <EmailsList 
        v-if="modals.emails" 
        :contacts="customer.ContactEmployees"
        :docNum="invoice.DocNum"
        @close="modals.emails = false"
      />
    </modal>
  <modal :show.sync="modals.newTracking" modal-classes="modal-dialog-centered modal-custom-size" @close="onCloseTracking">
      <NewTracking 
        v-if="modals.newTracking && invoice && customer && whseAddress"
        @add="onAddTracking"
        @edit="onEditTracking"
        @close="onCloseTracking"
        @openEditAddress="() => modals.editAddress = true"
        docType="invoice"
        :invBaseEntry="invoice.BaseEntry"
        :customer="customer"
        :warehouse="whseAddress"
        :currentTracking="currentTracking"
        :currentTrackingIndex="currentTrackingIndex"
      />
      <base-loader v-else style="height: 80vh; min-height: 500px;" />
    </modal>

    <modal :show.sync="modals.editAddress" modal-classes="modal-dialog-centered modal-md" @close="modals.editAddress = false;">
      <EditAddress
        v-if="modals.editAddress && invoice && customer"
        :shipToCode="invoice.ShipToCode"
        :customer="customer"
        @close="modals.editAddress = false;"
        @success="load()"
      />
    </modal>

  </div>
</template>

<script>
import axios from 'axios'
import BaseLoader from '@/components/BaseLoader.vue';
import moment from "moment";
import { getAuth } from "firebase/auth";
import currency from '@/data/currency.json'
import DocumentHistory from '@/components/DocumentHistory.vue';
import Formats from "@/mixins/Formats";
import EmailsList from './EmailsList.vue';
import TrackingNumbers from './TrackingNumbers.vue';
import NewTracking from './NewTracking.vue';
import EditAddress from './EditAddress.vue';
  export default {
    mixins: [Formats],
    components:{
      BaseLoader,
      DocumentHistory,
      EmailsList,
      TrackingNumbers,
      NewTracking,
      EditAddress
    },
    data() {
      return {
        HANA_URL: process.env.VUE_APP_HANA_URL,
        DATABASE: process.env.VUE_APP_DATABASE,
        user: null,
        invoice: null,
        docLines:[],
        customer: null,
        globalInformation: null,
        zipCode: null,
        paymentMethod: null,
        paymentGroup: null,
        modals:{
          complete: false,
          emails: false,
          newTracking: false,
          editAddress: false
        },
        regimenes: null,
        salesPersonOptions: null,
        downloadingPdf: false,
        downloadingXml: false,
        downloadingCouriersPdf: false,
        downloadingLayoutPDF: false,
        currency: null,
        stamping: false,
        canStamp: false,
        approvalStampEmails: [
          'brendaterrazas@canplast.com.mx',
          'estefaniasalas@canplast.com.mx',
          'idalyvillalobos@canplast.com.mx',
          'alfredoreyes@canplast.com.mx'
        ],
        whseAddress: null,
        shippingMethod: null,
        freightPayment: null,
        currentTracking: null,
        currentTrackingIndex: null,
        trackings: [],
        generating: false,
      }
    },

    methods: {
      generateTracking(){
        this.generating = true;
        const json = {
          query: `--sql
            SELECT 
              "DocNum"
            FROM ${this.DATABASE}."ODLN"
            WHERE "DocEntry" = ${this.invoice.BaseEntry}
            LIMIT 10
          `
        };
        axios.post(`${this.HANA_URL}/api/hana/freedom`, json)
        .then((res) => {
          if(res.data.length && res.data[0].DocNum){
            const delivery = res.data[0];
            const requests = this.trackings.map((json, index) => {
              console.log("generateTracking", index, json);
            
              const delUser = delivery.U_FulfillmentDeliveryUser;
              const ref = `FA ${this.invoice.DocNum}${delUser ? ` validado por ${delUser}` : ``}`
            
              if(json.origin){ // Envia
                json.origin.reference = ref;
                return axios.post(`api/envia/label/create`, json);
              } 
              else { // Paquetexpress
                json.invoiceReference = ref;
                return axios.post(`api/paquetexpress/label`, json);
              }
            
            });

            axios.all(requests)
              .then(axios.spread((...responses) => {
                  this.saveTracking(responses);
              }))
              .catch((e) => {
                this.generating = false;
                console.error(e);
                this.$swal("Error", `No se pudo generar la guía.`, "error")
              });

          } else {
            console.error("Error al obtener el número de entrega");
            this.generating = false;
          }
        })
        .catch((e) => {
          console.error("Error al obtener el número de entrega", e);
          this.generating = false;
        })
      },
      async saveTracking(responses) {
        const errors = [];

        for (let index = 0; index < responses.length; index++) {
          const res = responses[index];
          const tracking = this.trackings[index];

          for (let indexPkg = 0; indexPkg < tracking.packages.length; indexPkg++) {
            const pkg = tracking.packages[indexPkg];
            console.log("TRACKING", pkg, index);

            if (
              (res.data.meta && res.data.meta === "generate") || // Envia
              res.data.carrier // Paquetexpress
            ) {
              let t, guia, trackingId, cost, folio;

              if (res.data.meta && res.data.meta === "generate") {
                // Envia
                t = res.data.data[0];
                guia = t.shipmentId;
                trackingId = t.trackingNumber;
                cost = t.totalPrice;
                folio = t.folio;
              } else if (res.data.carrier) {
                // Paquetexpress
                t = res.data;
                guia = t.guia;
                trackingId = t.rastreo;
                cost = t.cost;
                folio = null;
              }

              const json = {
                Name: `${guia}-${indexPkg}`,
                Code: `${guia}-${indexPkg}`,
                U_DocNum: this.invoice.DocNum,
                U_DocType: "invoice",
                U_Carrier: t.carrier,
                U_Service: t.service,
                U_CreatedAt: moment().toISOString(),
                U_E_ShipmentId: guia,
                U_E_Folio: folio,
                U_TrackingId: trackingId,
                U_Cost: cost,
                U_TrackingStatus: "Pendiente de recolección",
                U_LabelLink: t.label,
                U_Weight: pkg.weight,
                U_Length: pkg.dimensions.length,
                U_Width: pkg.dimensions.width,
                U_Height: pkg.dimensions.height,
                U_LastEventDesc: "Pendiente de Recolección",
                U_LastEventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                U_EstimatedDeliveryDate: null,
                U_Comments: null,
                U_FromCedis: this.whseAddress.WarehouseCode.substring(0, 3),
              };

              try {
                await axios.post(`api/trkd/envioclick`, json);
              } catch (error) {
                console.error("Error al guardar tracking", error);
                errors.push(`Error al guardar la guía ${indexPkg}`);
              }
            } else {
              console.error("Error", index, res.data);
              if (res.data.error && res.data.error.message) {
                errors.push(res.data.error.description + " ", res.data.error.message);
              } else if (res.data.axios_request_err) {
                errors.push(res.data.axios_request_err);
              } else {
                errors.push(`No se pudo guardar la guía ${index}`);
              }
            }
          }
        }

        if (errors.length > 0) {
          this.$swal("Error", errors.join(", "), "error");
        } else {
          this.$swal("Creado", `Guías creadas correctamente`, "success");
          this.$refs.trackingNumbers.getTrackingNumbers();
          this.trackings = [];
          this.modals.newTracking = false;
          this.currentTracking = null;
          this.currentTrackingIndex = null;
        }

        this.generating = false;
      },
      openTracking(tracking, index) {
        this.currentTracking = tracking;
        this.currentTrackingIndex = index;
        this.modals.newTracking = true;
      },
      removeTracking(index) {
        this.trackings.splice(index, 1);
      },
      onAddTracking(json) {
        this.trackings.push(json);
      },  
      onEditTracking(json, index) {
        this.trackings[index] = json;
        this.currentTracking = null;
        this.currentTrackingIndex = null;
      },
      onCloseTracking() {
        this.modals.newTracking = false
        this.currentTracking = null;
        this.currentTrackingIndex = null;
      },
      openEmailsList(){
        this.modals.emails = true;
      },
      stampInvoice(){
        this.stamping = true;
        axios
          .post(`api/fpt/reinvoice?DocEntry=${this.invoice.DocEntry}`)
          .then((res) => {
            if(res.data.DocNum){
              this.$swal({
                title: "Factura Timbrada",
                text: `La factura #${res.data.DocNum} ha sido timbrada correctamente`,
                icon: "success",
              });
              this.load();
            } else if(res.data.msg){
              this.$swal({
                title: "Error",
                text: res.data.msg,
                icon: "error",
              });
            } else {
              console.error("Error", res.data)
              this.$swal({
                title: "Error",
                text: "Ocurrió un error al timbrar la factura",
                icon: "error",
              });
            }
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.stamping = false;
          });
      },
      invoicePDF(){
        this.downloadingPdf = true;
        const json = {
          "DocCode": "INV20024",
          "Pairs": {
            "DocKey@": this.invoice.DocEntry
          }
        };
        axios.post(`/api/pdf_file`,json)
        .then(res => {
          if(res.data.se_err){
            this.$swal("Error", res.data.se_err.message, "error");
          } else {
            let link = document.createElement('a');
            link.download = `Factura_${this.invoice.DocNum}.pdf`;
            link.href =  res.data.base64;
            link.click();

            if(!this.invoice.U_WebPrintedBy){
              this.$swal({
                title: "Marcar como impresa", 
                text: `¿Deseas marcar la Factura #${this.invoice.DocNum} como impresa?`, 
                icon: "question",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCancelButton: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  axios
                    .patch(`api/invoices/update?DocEntry=${this.invoice.DocEntry}`, {U_WebPrintedBy: this.user.email})
                    .then((res) => {
                      if(res.data.msg){
                        this.$swal("Impresa", `La factura #${this.invoice.DocNum} ha sido marcada como impresa`, "success");
                        this.load();
                      } else if(res.data.sl_err && res.data.sl_err.error){
                        this.$swal(
                          "Error", 
                          `No se pudo marcar como impresa la factura #${this.invoice.DocNum}. \n ${res.data.sl_err.error.message.value}`, "error"
                        );
                      } else {
                        this.$swal("Error", `No se pudo marcar como impresa la factura #${this.invoice.DocNum}`, "error");
                        console.error(res.data)
                      }
                    })
                    .catch((error) => {
                      this.$swal("Error", `No se pudo marcar como impresa la factura #${this.invoice.DocNum}`, "error");
                      console.error(error);
                    });
                }
              }).catch((error) => {
                console.error(error);
              });
            } 

          }
        }).catch(error => {
          console.error(error);
        }).finally(() => {
          this.downloadingPdf = false;
        });
      },
      invoiceXML(){
        if(this.invoice.U_WebXML){
          let link_xml = document.createElement('a');
          link_xml.download = `Factura_${this.invoice.DocNum}.xml`;
          link_xml.href = this.invoice.U_WebXML;
          link_xml.target = '_blank';
          document.body.appendChild(link_xml);
          link_xml.click();
          document.body.removeChild(link_xml);
        } else if (this.invoice.U_TS_ReportID){
          const [año, mes, dia] = this.invoice.DocDate.split("-");
          const download = `https://canplast.net:50000/api/v1/sap/xml/${año}/${mes}/${dia}/${this.invoice.CardCode}/${this.invoice.CardName}/${this.invoice.U_TS_ReportID}?token=${localStorage.getItem('token-cpm')}`
          window.open(download, '_blank');
        } else {
          this.downloadingXml = true;
          fetch(`https://canplast.net:50000/api/v1/sap/GET/Invoice/UUID/${this.invoice.DocNum}`, {
						method: 'GET',
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'x-access-token': localStorage.getItem('token-cpm')
						}
					})
					.then((response) => response.json())
					.then((responseJson) => {
            if(responseJson.UUID){
              const [año, mes, dia] = this.invoice.DocDate.split("-");
              const download = `https://canplast.net:50000/api/v1/sap/xml/${año}/${mes}/${dia}/${this.invoice.CardCode}/${this.invoice.CardName}/${responseJson.UUID}?token=${localStorage.getItem('token-cpm')}`
              window.open(download, '_blank');
            } else {
              this.$swal("Error", "No se pudo obtener el XML", "error");
            }
          })
          .catch((error) => {
            console.error(error);
          }).finally(() => {
            this.downloadingXml = false;
          });
        }
      },
      layoutPDF(){
        this.downloadingLayoutPDF = true;
        const json = {
          "DocCode": "INV20027",
          "Pairs": {
            "DocKey@": this.invoice.DocEntry
          }
        };
        axios.post(`/api/pdf_file`,json)
        .then(res => {
          if(res.data.base64){
            let link = document.createElement('a');
            link.download = `Factura_sin_precios_${this.invoice.DocNum}.pdf`;
            link.href =  res.data.base64;
            link.click();
          } else if(res.data.se_err){
            this.$swal("Error", res.data.se_err.message, "error");
          } else {
            this.$swal("Error", "No se pudo obtener el PDF", "error");
            console.error("Error", res.data);
          }

        }).catch(error => {
          console.error(error); 
        }).finally(() => {
          this.downloadingLayoutPDF = false;
        });
      },
      couriersPDF(){
        this.downloadingCouriersPdf = true;
        const json = {
          "DocCode": "INV20028",
          "Pairs": {
            "DocKey@": this.invoice.DocEntry
          }
        };
        axios.post(`/api/pdf_file`,json)
        .then(res => {
          if(res.data.base64){
            let link = document.createElement('a');
            link.download = `Papeleta_envio_${this.invoice.DocNum}.pdf`;
            link.href =  res.data.base64;
            link.click();
          } else if(res.data.se_err){
            this.$swal("Error", res.data.se_err.message, "error");
          } else {
            this.$swal("Error", "No se pudo obtener el PDF", "error");
            console.error("Error", res.data);
          }

        }).catch(error => {
          console.error(error); 
        }).finally(() => {
          this.downloadingCouriersPdf = false;
        });
      },
      formatDate(date){
        return moment(date).format('YYYY-MM-DD');
      },
      load(){

      axios.get(`api/invoice?DocNum=${this.$route.params.DocNum}`)
      .then(res => {
        this.invoice = res.data.value[0];
        // console.log("INVOICE", this.invoice)

        this.currency = currency.find(x => x.key === this.invoice.DocCurrency);

        this.paymentMethod = this.invoice.PaymentMethod === '99' ? 'PPD' : 'PUE';

        axios.get(`/api/paymentsByCode?code=${this.invoice.PaymentGroupCode}`)
        .then(res => {
          this.paymentGroup = res.data.value.find(x => x.GroupNumber === this.invoice.PaymentGroupCode);
        }).catch(err => {
          console.error(err);
        });

        axios.get(`api/warehouses/${this.invoice.DocumentLines[0].WarehouseCode}`)
        .then(res => {
          this.whseAddress = {
            "WarehouseCode": res.data.value[0].WarehouseCode,
            "Street": res.data.value[0].Street,
            "StreetNo": res.data.value[0].StreetNo,
            "ZipCode": res.data.value[0].ZipCode,
            "Block": res.data.value[0].Block,
            "BuildingFloorRoom": res.data.value[0].BuildingFloorRoom,
            "City": res.data.value[0].City,
            "Country": res.data.value[0].Country,
            "State": res.data.value[0].State,
          };
          this.zipCode = res.data.value[0].ZipCode
          
        }).catch(err => {
          console.error(err);
        });

        axios.get(`/api/business_partners?card_code=${this.invoice.CardCode}`)
        .then(res => {
          this.customer = res.data;
        }).catch(err => {
          console.error(err);
        });

        axios.get(`api/user_fields/ShippingMethod`)
        .then(res => {
          this.shippingMethod = res.data.value[0].ValidValuesMD.find(x => x.Value === this.invoice.U_ShippingMethod);
        }).catch(err => {
          console.error(err); 
        });

        axios.get(`api/user_fields/FreightPayment`)
        .then(res => {
          this.freightPayment = res.data.value[0].ValidValuesMD.find(x => x.Value === this.invoice.U_FreightPayment);
        }).catch(err => {
          console.error(err); 
        });

      }).catch(err => {
        console.error(err);
      })
      },
    },
    created(){
      this.user = getAuth().currentUser;
      this.approvalStampEmails.includes(this.user.email) ? this.canStamp = true : this.canStamp = false;

      this.load();

      axios.get(`/api/regimen_fiscal`)
      .then(res => {
        this.regimenes = res.data;
      }).catch(err => {
        console.error(err);
      });

      axios.get(`/api/sales_persons`)
      .then((response) => {
        this.salesPersonOptions = response.data.value;
      }).catch((error) => {
        console.error(error);
      });

    }

  }
</script>

<style scoped>
.custom-side-cards{
  min-width: 100%;
  width: 100%;
}
@media (min-width:1200px) {
  .custom-side-cards {
    min-width: 360px;
    width: 360px;
  }
}

.custom-table{
  th, td {
    padding: 12px 12px;
    
  }
  td{
    vertical-align: middle;
  }
  td:first-child, 
  th:first-child {
    padding-left: 24px; /* Ajusta el padding que quieras */
  }

  td:last-child, 
  th:last-child {
    padding-right: 24px; /* Ajusta el padding que quieras */
  }
}

.remove-button {
  background-color: white;
  height: 20px;
  width: 20px;
  border-radius: 0.375rem;
  color: #f5365c;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.remove-button:hover {
  background-color: #fee2e2;
}
</style>

<style>
.modal-custom-size {
  max-width: 1100px;
}
</style>